import { render } from "./ColumnMappings.vue?vue&type=template&id=00db369a"
import script from "./ColumnMappings.vue?vue&type=script&lang=ts"
export * from "./ColumnMappings.vue?vue&type=script&lang=ts"
script.render = render

export default script